<template>
  <div
    v-if="giftGivingReportQuestions.hasOwnProperty('delivery_relation')"
    id="delivery-report"
    class="question"
  >
    <h2
      class="header"
      :class="{ required: giftGivingReportQuestions.delivery_relation.required }"
    >
      1. {{ giftGivingReportQuestions.delivery_relation.label }}
    </h2>
    <div class="content">
      <p>
        {{ giftGivingReportQuestions.delivery_relation.sub_label }}
      </p>
      <v-layout wrap>
        <v-flex
          xs12
          :mt-3="xsOnly"
        >
          <ul>
            <li
              v-for="(item, index) in giftGivingReportQuestions.delivery_relation.text"
              :key="index"
              class="f-1"
            >
              {{ item }}
            </li>
          </ul>
          <v-textarea
            v-model.trim="deliveryReport"
            v-validate="{
              ...limitRegularLongField(
                giftGivingReportQuestions.delivery_relation.required,
              )
            }"
            auto-grow
            rows="8"
            class="mt-3"
            :placeholder="$t('placeholders.add_text')"
            :error-messages="errors.collect('deliveryReport')"
            data-vv-name="deliveryReport"
            :data-vv-as="' '"
            :disabled="readOnly"
            @focusout="reValidate"
          />
          <p
            class="f-14 mt-1 ml-1"
            :class="{ 'sz_red--text': isMinRule }"
          >
            {{
              $t('message.info_text_length', {
                stringMin: FIELD_MIN_LIMIT,
                stringLength: deliveryReport != null ? deliveryReport.length : 0
              })
            }}
          </p>
        </v-flex>
      </v-layout>
    </div>
    <v-divider class="my-4" />
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';
import { mapGetters } from 'vuex';
import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';
import { FIELD_LENGTH } from '@/constants/validationRules';

const { mapFields } = createHelpers({
    getterType: 'giftGivingReport/getGiftGivingReportState',
    mutationType: 'giftGivingReport/updateGiftGivingReportState'
});

export default {
    name: 'DeliveryReport',
    mixins: [sheetValidationRules],
    inject: ['$validator'],
    props: {
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            FIELD_MIN_LIMIT: FIELD_LENGTH.MIN_MIDDLE_FIELD_LENGTH
        };
    },
    computed: {
        ...mapFields(['deliveryReport']),
        ...mapGetters('giftGivingReport', ['giftGivingReportQuestions']),
        xsOnly () {
            return this.$vuetify.breakpoint.xsOnly;
        },
        isMinRule () {
            return this.errors.items.some((el) => {
                return el.field === 'deliveryReport' && el.rule === 'min';
            });
        }
    },
    methods: {
        reValidate () {
            this.$validator.validate('deliveryReport', this.deliveryReport.trim());
        }
    }
};
</script>

<style scoped></style>
